<template>
    <div>
        <Chart :cdata="cdata" />
    </div>
</template>

<script>
import Chart from './chart.vue';
import { universalQueryResult } from '../../api/holdMy';
export default {
    data() {
        return {
            cdata: {
                rateData: [],
                avgRunDayMonthly: 0,
            },
            drawTiming: null,
            averageMachine: []
        };
    },
    components: {
        Chart,
    },
    mounted() {
        this.drawTimingFn();
        // this.setData();

    },
    beforeDestroy() {
        clearInterval(this.drawTiming);
    },
    methods: {
        drawTimingFn() {
            this.getUniversalQueryResult();
            this.drawTiming = setInterval(() => {
                this.getUniversalQueryResult();
            }, 6000*5);
        },

        // 根据自己的业务情况修改
        async setData() {
            // 清空轮询数据
            this.cdata.rateData = [];
            var data = [
                { value: this.averageMachine[0].totalTime, name: '工作' },
                { value: this.averageMachine[0].effectTime, name: '有效' },
                { value: (this.averageMachine[0].totalTime - this.averageMachine[0].effectTime).toFixed(1), name: '平均待机' },
            ];
            this.cdata.rateData = data;
            this.cdata.avgRunDayMonthly = this.averageMachine[0].avgRunDayMonthly;
        },

        getUniversalQueryResult() {
            universalQueryResult("大数据台班月平均效率").then(res => {
                if (res.result == 0) {
                    this.averageMachine = res.rows
                    this.setData();
                }
            }).catch(error => {
                console.log(error);
            })
        },
    }
};
</script>

<style lang="scss" scoped></style>